import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Header, EditableCode, Line, Space } from './components';
import { Typography } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper
  },
  description: {
    paddingTop: '2vh',
    fontSize: '16px',
    color: '#4e4e4e',
    textAlign: 'left',
    marginRight: '3vw',
    marginLeft: '3vw'
  }
}));

const QuickCodes = () => {
  window.scrollTo(0, 0)
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Header />
      <Space />
      <Typography className={classes.description} >Main:</Typography>
      <EditableCode code=
        {`
// Decimal to Hex converter
(10).toString(16)		// Return: 'a'


// Hex to Decimal converter
parseInt('a', 16)		// Return: 10

// Hex to Char converter
String.fromCharCode(parseInt('49', 16))	// Return: 'I'


// Char to Hex converter 
('I').charCodeAt(0).toString(16)		// Return: '49'
('AI').charCodeAt(1).toString(16)		// Return: '49'


// Fill string
("000" + str).slice(-3)


// Clone object
var newObj = {...obj}


// Convert To Number
parseInt('10')                      // Return: 10
parseFloat('10.20')                 // Return: 10.2


// Replaces all occurrences
String.prototype.replaceAll = function (search, replacement) {
  var target = this;
  return target.split(search).join(replacement);
};


// Call Promise function:
myFunction().then( response => {
  console.log(response)
}, err => {
  console.log(err)
})
      
        `} />
      <Space />
      <Typography className={classes.description} >Queue:</Typography>
      <EditableCode code=
        {`
const Queue = require("promise-queue")
Queue.configure(require('vow').Promise)

var queue = new Queue(1, 10000)
var list = []

queue.add(f => myFunction()).then(resp => {  // myFunction() have to contain a Promise
    list.push(resp)
    if (list.length == 1)
        return list
})


// Promise with try catch
function myFunction(){
    return new Promise( (resolve, reject) => {
        try{
            // ...
            return resolve(true)
        }catch(err){
            return reject(err)
        }
    })
}  

        `} />

      <Space />
      <Typography className={classes.description} >Event:</Typography>
      <EditableCode code=
        {`
var events = require('events');
global.foo = new events();

// Can be in any file
foo.on('anything', function (data) {
  ...
})
    
// Can be in any file
function myFunc(){
  foo.emit('anything', false);
}

        `} />

      <Space />
      <Typography className={classes.description} >Array Manipulation:</Typography>
      <EditableCode code=
        {`
var list = [1, 2, 3, 4, 5]

// Array: get last element
list.slice(-1)              // Return: [5]
list.slice(-1)[0]           // Return: 5

// Array: get range element
list.slice(1, -1)           // Return: [2, 3, 4]

// Array: get after an element
list.slice(1, 3)            // Return: [2, 3]

// Array: remove first element
list.splice(0, 1)           // Return: [1]      | list == [2, 3, 4, 5]

// Array: remove last element
list.pop()                  // Return: 5        | list == [1, 2, 3, 4]
list.splice(-1)             // Return: [5]      | list == [1, 2, 3, 4]
list.splice(-1)[0]          // Return: 5        | list == [1, 2, 3, 4]

// Array: remove after an element
list.splice(2)              // Return: [3, 4, 5]    | list == [1, 2]

// Array: remove after an element
list.splice(2, 1)           // Return: [3]          | list == [1, 2, 4, 5]
list.splice(2, 2)           // Return: [3, 4]       | list == [1, 2, 5]

// Array: remove and insert element
list.splice(2, 1, 9)        // Return: [3]          | list == [1, 2, 9, 4, 5]


        `} />

      <Space />
      <Typography className={classes.description} >HTTP Web server:</Typography>
      <EditableCode code=
        {`
const http = require('http')
const express = require('express')
const app = express()

const port = 5050
http.createServer(app)

app.listen(port, () => {
    console.log('server running...')
})

app.use(express.static('public'));    // public folder: add static files, such as: index.html, Lib folder, etc.
        `} />

      <Space />
      <Typography className={classes.description} >Tests with Tape module:</Typography>
      <EditableCode code=
        {`
var tape = require('tape')
var tapePromise = require('tape-promise').default
var test = tapePromise(tape)

// With Promise
test('Main functions:', async (t) => {

    await myFunction1('param').then(resp => {
        t.assert(resp === '0001', "myFunction1(): OK")
    })
	
    await myFunction2('param').then(obj => {
        t.deepEqual(obj, {
            param1: 1,
            param2: 'abcd',
        }, "myFunction2(): OK")
    })
	
    t.end()
})

// Without Promise
test('Main functions:', (t) => {
  t.assert(myFunction1('param') === '0001', "myFunction1(): OK")
  t.deepEqual(myFunction2('param'), { param1: 1, param2: 'abcd' }, "myFunction2(): OK")
  t.end()
})
        `} />
      <Line />
      <EditableCode code=
        {`
// File package.json   
"scripts": {
    "test": "node test/index.js | tap-spec"
},
        `} />

      <Space />
      <Typography className={classes.description} >Definitions:</Typography>
      <EditableCode code=
        {`
0 == false      // Return: true
1 == true       // Return: true
false == null   // Return: false
false > null    // Return: false
false >= null   // Return: true   // NOTE: When the symbols '<' and '>' are used, null will become 0 and undefined = NaN
        `} />
      <Line />

    </div>
  );
};

export default QuickCodes;
